import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import jobsApi from '../../../APIs/jobs';
import {
  JobInformation,
  JobTimeline,
  PropertyInformation,
  ProposalAcceptence,
  ProposalDetail,
  TechnicalNote,
  TechnicalSpecification,
  WorkApproach,
} from '../../../components/MyJobs';
import ClientReviewAndJobProcessStatus from '../../../components/MyJobs/ClientReviewAndJobProcessStatus';
import {
  Button,
  Divider,
  Modal,
  NavigateBack,
  Typography,
} from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { humanReadableDate, requestAPI } from '../../../utils';
import { ViewJobContainerStyled } from '../../BrowseJobs/BrowseJobDetails/style';
import AddPrinterJob from '../../CreateJobs/CreateNewJobs/AddPrinterJob';
import { DescriptionContainer } from './style';

const ViewMyJobs = () => {
  const { myJobProposalId } = useParams();
  const jobDetails = useSelector((state: RootState) => state.jobAndProposal);

  const getJobAndProposal = async (jobAndProposalId: string) => {
    try {
      await requestAPI(jobsApi.getJobAndProposalById(jobAndProposalId));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (myJobProposalId) {
      getJobAndProposal(myJobProposalId);
    }
  }, [myJobProposalId]);

  const technicianJob =
    typeof jobDetails?.technicianJobId === 'string'
      ? undefined
      : jobDetails?.technicianJobId;

  const acceptedProposal =
    typeof jobDetails?.acceptedProposal === 'string'
      ? undefined
      : jobDetails?.acceptedProposal;

  const building =
    typeof technicianJob?.building === 'string'
      ? undefined
      : technicianJob?.building;
  const proposalCreatedBy =
    typeof acceptedProposal?.createdBy === 'string'
      ? undefined
      : acceptedProposal?.createdBy;
  console.log(proposalCreatedBy, 'proposal');
  return (
    <ViewJobContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
          background: '#fff',
        }}
      >
        <NavigateBack />
      </div>
      <div className="contents">
        <div style={{ marginBottom: '20px' }}>
          <Typography variant="title" strong>
            Job Details
          </Typography>
        </div>
        <DescriptionContainer>
          <ClientReviewAndJobProcessStatus jobAndProposalId={myJobProposalId} />
          <Divider />

          <JobInformation
            createdAt={technicianJob?.createdAt || ''}
            jobTitle={technicianJob?.jobTitle || ''}
            notes={acceptedProposal?.notes || ''}
          />
          <Divider />

          <PropertyInformation
            buildingName={building?.buildingName || ''}
            buildingAddress={building?.buildingAddress || ''}
          />
          <Divider />
          <ProposalDetail
            events={acceptedProposal?.proposalStatusChangedDate?.map(
              (pStatus) => ({
                date: humanReadableDate(pStatus.changeAt),
                title:
                  pStatus.status === 'ACTIVE'
                    ? 'Proposal Created'
                    : 'Proposal Decided',
                description:
                  pStatus.status === 'ACCEPT'
                    ? `${proposalCreatedBy?.fullName}'s proposal accepted.`
                    : pStatus.status === 'REJECT'
                      ? 'Proposal Rejected'
                      : 'Created',
              })
            )}
          />

          <Divider />

          <ProposalAcceptence
            avatar={proposalCreatedBy?.avatar}
            name={proposalCreatedBy?.fullName}
            email={proposalCreatedBy?.emailAddress}
          />
          <Divider />

          <TechnicalSpecification
            specification={acceptedProposal?.specification || ''}
            experience={acceptedProposal?.experience || ''}
            cost={acceptedProposal?.cost || ''}
            qualifications={acceptedProposal?.qualifications || ''}
            pastReferences={acceptedProposal?.pastProject}
          />
          <Divider />

          <WorkApproach
            workApproach={acceptedProposal?.workApproach || ''}
            riskAssessment={acceptedProposal?.riskAssessment || ''}
            designApproach={acceptedProposal?.designApproach || ''}
          />
          <Divider />
          <JobTimeline
            events={[
              {
                date: humanReadableDate(acceptedProposal?.startingDate),
                title: 'Job starting proposed date.',
              },
              {
                date: humanReadableDate(acceptedProposal?.endDate),
                title: 'Job completion proposed date.',
              },
            ]}
          />
          <Divider />
          <TechnicalNote notes={acceptedProposal?.notes || ''} />
          <Divider />
        </DescriptionContainer>
      </div>
    </ViewJobContainerStyled>
  );
};

export default ViewMyJobs;
